import { fromJS } from 'immutable';
import normaliseResponse from 'utils/normaliseResponse';

import * as constants from 'actions/paymentMethods/constants';
import initialState from './initialState';

export default (state = initialState, action) => {
  switch (action.type) {
    case constants.GET_PAYMENT_METHODS_SUCCESS: {
      const { paymentMethods, projectId } = action;

      const prevAllIds = state.get('allIds') || [];

      const normalisedResponse = normaliseResponse(paymentMethods);
      const { byId } = normalisedResponse;
      const allIdsByProject = normalisedResponse.allIds;
      const allIds = prevAllIds.concat(
        allIdsByProject.filter((id) => prevAllIds.indexOf(id) < 0)
      );

      return state
        .mergeDeepIn(['byId'], fromJS(byId))
        .set('allIds', fromJS(allIds))
        .setIn(['byProjectId', `${projectId}`], fromJS(allIdsByProject));
    }

    // TODO: uncomment when backend returns data from POST
    // case constants.ADD_PAYMENT_METHOD_SUCCESS: {
    //   const { projectId, paymentMethod } = action
    //   const { id } = paymentMethod
    //
    //   // We can't use mergeDeepIn because, if one of the keys is not specified,
    //   // it breaks.
    //   return state
    //     .setIn(['byId', id], fromJS(paymentMethod))
    //     .mergeDeep(fromJS({ allIds: [id] }))
    //     .mergeDeep(fromJS({ byProjectId: { [projectId]: [id] } }))
    // }
    //
    default:
      return state;
  }
};
